import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { TestPage } from "src/components/views/TestPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/devTest")({
	staticData: { title: i18n.t("test"), legacyViewKey: "devTestView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <TestPage />;
}
